import InfoTable from "@/components/InfoTable.vue";

export default {
	components: {
		InfoTable
	},
	methods: {
		setData(data) {
			this.$refs["baseInfoTable"].setData(data);
		}
	},
	props: {
		info: {
			type: Object,
			default: function() {
				return {
					_id: ""
				};
			}
		},
		recordId: {
			type: String,
			default: ""
		}
	}
};
